import { differenceInCalendarDays, format, parseISO } from "date-fns";
var DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
var FORMAT_PATTERNS = {
  "date-input": "yyyy-MM-dd",
  "short-date": "MMM d, yyyy",
  "long-date": "MMMM d, yyyy",
  "day-month": "MMM d",
  "date-time": "MMM d, yyyy · HH:mm",
  time: "h:mm a"
};

/** Parses a UTC or ISO date string into a local Date, or null when missing or invalid. */
export function parseUtcDate(value) {
  if (!value) return null;
  var date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Formats a UTC or ISO date string in local time using the requested style, or the fallback. */
export function formatUtcDate(value, style) {
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var date = parseUtcDate(value);
  return date ? format(date, FORMAT_PATTERNS[style]) : fallback;
}

/** Converts a UTC or ISO date string to the local 'yyyy-MM-dd' value used by date inputs, preserving date-only values as-is. */
export function toDateInputValue(value) {
  if (!value) return "";
  if (DATE_ONLY_PATTERN.test(value)) return value;
  return formatUtcDate(value, "date-input");
}

/** Converts a local 'yyyy-MM-dd' date-input value back to a local-midnight ISO string. */
export function fromDateInputValue(dateInput) {
  if (!dateInput) return "";
  var date = parseISO(dateInput);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
}

/** Returns whole calendar days from today to the given date; negative when past, or null when invalid. */
export function calendarDaysUntil(value) {
  var date = parseUtcDate(value);
  return date ? differenceInCalendarDays(date, new Date()) : null;
}